module.exports = __webpack_public_path__ + "static/media/loader.43e64ee4.svg";